import { DataGrid as MuiDataGrid, type DataGridProps } from "@mui/x-data-grid";

export type { DataGridProps };
export type {
  GridColDef,
  GridRowsProp,
  GridRowParams,
  GridCellParams,
  GridRenderCellParams,
  GridRowSelectionModel,
  GridSortModel,
  GridFilterModel,
  GridPaginationModel,
} from "@mui/x-data-grid";

export function DataGrid(props: DataGridProps) {
  return <MuiDataGrid {...props} />;
}
